import { useState } from 'react'

import { Controller } from 'react-hook-form'

import IconChevronDown from '@/assets/icons/icon-chevron-down.svg'
import IconPlus from '@/assets/icons/icon-plus.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'
import { ToggleSection } from '@/modules/tasks/components/create-task-dialog/toggle-section.tsx'
import { useIcon } from '@/modules/tasks/components/icons'
import { useTaskQuery } from '@/modules/tasks/query/task-query-context'
import { classNames } from '@/utils/helpers'

export interface ListSelectorProps {
  onOpenCreateLink: () => void
}

export const ListSelector = (props: ListSelectorProps) => {
  const { onOpenCreateLink } = props
  const { lists } = useTaskQuery()
  const [active, setActive] = useState(true)

  return (
    <Controller
      name="taskList"
      render={function ListSelectorField({ field, fieldState: { error } }) {
        const selectedIcon = useIcon(field.value?.icon, field.value?.color)

        return (
          <div className="flex flex-col gap-2">
            <ToggleSection
              label="List"
              labelFor="taskList"
              className="w-full justify-between"
              enabled={active}
              onToggle={() => {
                setActive(!active)
              }}
            >
              <DropdownMenu>
                <DropdownMenuTrigger className="flex w-[240px] items-center justify-between rounded-md border bg-card px-3 py-2 text-title focus:border-primary-500 focus:outline-primary-500">
                  {field.value ? (
                    <span className="flex items-center gap-1">
                      {selectedIcon}
                      {field.value.name}
                    </span>
                  ) : (
                    <span>Select list</span>
                  )}
                  <IconChevronDown className="ml-auto h-4 w-4 flex-shrink-0 text-title" />
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  className="z-[100] w-64"
                  align="start"
                  forceMount
                >
                  <DropdownMenuGroup className="flex flex-col gap-[16px]">
                    {lists.map(function Item(list) {
                      const icon = useIcon(list.icon, list.color)

                      return (
                        <DropdownMenuItem
                          key={list.id}
                          onClick={() => field.onChange(list)}
                          className={classNames(
                            'group -m-2 flex items-center gap-1 rounded-md px-2 font-medium',
                            {
                              'bg-primary-500 text-white hover:bg-primary-400':
                                list.id === field.value?.id,
                              'text-title hover:bg-primary-500/20 hover:text-primary-500 ':
                                list.id !== field.value?.id,
                            },
                          )}
                        >
                          {icon}
                          {list.name}
                        </DropdownMenuItem>
                      )
                    })}
                    <DropdownMenuItem
                      onClick={onOpenCreateLink}
                      className="group -m-2 gap-1 rounded-md px-2 font-medium text-primary-500 hover:bg-primary-500/20"
                    >
                      <IconPlus /> Create New List
                    </DropdownMenuItem>
                  </DropdownMenuGroup>
                </DropdownMenuContent>
              </DropdownMenu>
            </ToggleSection>
            {error && (
              <p className="mt-2 text-xs text-danger-default">
                {error.message}
              </p>
            )}
          </div>
        )
      }}
    />
  )
}
